/**
 * @generated SignedSource<<9c409d2fbbbb1c5e7fc6a4bfdac9a20c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutPhoneLink_viewer$data = {
  readonly contactInfo: {
    readonly phoneNumbers: {
      readonly defaultSupport?: string | null;
      readonly defaultTradeSupport?: string | null;
      readonly intlSupport?: string | null;
      readonly tradeSupport?: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "CheckoutPhoneLink_viewer";
};
export type CheckoutPhoneLink_viewer$key = {
  readonly " $data"?: CheckoutPhoneLink_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutPhoneLink_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "INTERNATIONAL"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasTradeStatus"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutPhoneLink_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactInfo",
      "kind": "LinkedField",
      "name": "contactInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "support",
          "kind": "LinkedField",
          "name": "phoneNumbers",
          "plural": false,
          "selections": [
            {
              "condition": "hasTradeStatus",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "alias": "intlSupport",
                  "args": (v0/*: any*/),
                  "kind": "ScalarField",
                  "name": "support",
                  "storageKey": "support(formatType:\"INTERNATIONAL\")"
                },
                {
                  "alias": "defaultSupport",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "support",
                  "storageKey": null
                }
              ]
            },
            {
              "condition": "hasTradeStatus",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": null,
                  "args": (v0/*: any*/),
                  "kind": "ScalarField",
                  "name": "tradeSupport",
                  "storageKey": "tradeSupport(formatType:\"INTERNATIONAL\")"
                },
                {
                  "alias": "defaultTradeSupport",
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tradeSupport",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "44d9df33e0f022dc472907eaf3199e77";

export default node;
